import { Directive, ElementRef, HostListener, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({ selector: '[appCpfCnpj]' })
export class CpfCnpjDirective {
  constructor(
    private el: ElementRef<HTMLInputElement>,
    @Optional() @Self() private ngControl: NgControl
  ) {}

  @HostListener('input')
  onInput(): void {
    const stripped = this.el.nativeElement.value
      .replace(/[^A-Z0-9]/gi, '')
      .toUpperCase()
      .slice(0, 14);

    const formatted = stripped.length <= 11 ? this.formatCpf(stripped) : this.formatCnpj(stripped);

    this.el.nativeElement.value = formatted;
    this.ngControl?.control?.setValue(formatted, { emitEvent: false });
  }

  private formatCpf(s: string): string {
    let r = '';
    for (let i = 0; i < s.length; i++) {
      if (i === 3 || i === 6) r += '.';
      else if (i === 9) r += '-';
      r += s[i];
    }
    return r;
  }

  private formatCnpj(s: string): string {
    let r = '';
    for (let i = 0; i < s.length; i++) {
      if (i === 2 || i === 5) r += '.';
      else if (i === 8) r += '/';
      else if (i === 12) r += '-';
      r += s[i];
    }
    return r;
  }
}
